// © 2015-2021 WDNA - All Rights Reserved
import { config } from '../../config/config';

import API from './API';

export type { AxiosRequestConfig } from 'axios';

const { apiRootUrl } = config;

const Connect: API = new API({
  baseURL: apiRootUrl,
  headers: { 'Content-Type': 'application/json' },
});

export default Connect;
